import { render, staticRenderFns } from "./RightContent.vue?vue&type=template&id=6048df08&scoped=true&"
import script from "./RightContent.vue?vue&type=script&lang=js&"
export * from "./RightContent.vue?vue&type=script&lang=js&"
import style0 from "./RightContent.vue?vue&type=style&index=0&id=6048df08&lang=less&"
import style1 from "./RightContent.vue?vue&type=style&index=1&id=6048df08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6048df08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6048df08')) {
      api.createRecord('6048df08', component.options)
    } else {
      api.reload('6048df08', component.options)
    }
    module.hot.accept("./RightContent.vue?vue&type=template&id=6048df08&scoped=true&", function () {
      api.rerender('6048df08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalHeader/RightContent.vue"
export default component.exports